import { render, staticRenderFns } from "./BaseFileUploader.vue?vue&type=template&id=aa584766&scoped=true&"
import script from "./BaseFileUploader.vue?vue&type=script&lang=js&"
export * from "./BaseFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileUploader.vue?vue&type=style&index=0&id=aa584766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa584766",
  null
  
)

export default component.exports